// extracted by mini-css-extract-plugin
export default {"container":"Maa-z","productName":"Naa-z","price":"Oaa-z","dimensions":"Paa-z"};